import { useSendCommandAsync } from '@/_core/cqrs/use';
import { RealTimeAction } from '@/_core/fluxstore/types';
import { createUpdatePersonaPictureCommand } from '../../../api/commands/factory/createPersonaCommands';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class SelectPersonaAvatar extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'SelectPersonaAvatar';

    public constructor(public id: string, public avatarId: string) {
        super(SelectPersonaAvatar.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SelectPersonaAvatar): Promise<boolean> => {
    useSendCommandAsync(action, {
        createCommand: async () => await createUpdatePersonaPictureCommand(action),
    });

    return true;
};

const reducer = (state: StorymapState, action: SelectPersonaAvatar): void => {
    const persona = state.personas.find((x) => x.id === action.id);
    const avatar = state.personaPictures.find(x => x.id == action.avatarId);
    persona.picture = avatar.path;
};

//@ts-ignore
registerMiddleware(SelectPersonaAvatar.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SelectPersonaAvatar.ACTION_TYPE, reducer);
